import {
  DRIFT_CHAT_APP_USERS_DIMENSIONS,
  DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS,
} from 'cube/constants'

import { CubeQuery } from '@driftt/dds.reports'

export const FastlaneEndUserActivityQuery: CubeQuery = {
  name: 'FastlaneEndUserActivityQuery',
  queryName: 'FastlaneEndUserActivityQuery',
  query: {
    dimensions: [
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.EVENT_ID,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.EVENT_TYPE,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.EVENT_CREATED_AT,
      DRIFT_CHAT_APP_USERS_DIMENSIONS.NAME,
    ],
  },
}
